import axios from '@/libs/api.request'

/**
 * 登录
 */
export const login = (username, password, yzm) => {
    const data = {
        "username": username,
        "password": password,
        "yzm": yzm
    }
    return axios.request({
        url: '/api/admin/login',
        data,
        method: 'post'
    })
}

/**
 * 登出
 */
export const loginOut = (username, password) => {
    return axios.request({
        url: '/api/admin/logout',
        method: 'post'
    })
}

/**
 * 修改密码
 */
export const changePass = (oldPass, newPass) => {
    const data ={
        "oldPass": oldPass,
        "newPass": newPass
    }
    return axios.request({
        url: '/api/admin/user/changePassword',
        data,
        method: 'post'
    })
}

/**
 * 修改密码
 */
 export const continueSession = () => {
    return axios.request({
        url: '/api/admin/continueSession',
        method: 'post'
    })
}

/**
 * 签名
 */
 export const getSignature = () => {
    return axios.request({
        url: '/api/api/wechat/getSignature',
        method: 'post'
    })
}